import React from 'react';
import FormInstance from './form-instance';
export var FormInstanceContext = React.createContext(new FormInstance());
//# sourceMappingURL=form-instance-context.js.map